import { FormattedVerificationTransactionsResponse, VerificationTransactionsResponse } from "@idw-types/data/reports";
import { formatVerificationTransactions } from "../verification-transactions/verification-transactions-formatter";
import { AxnRelyingParty } from "@idw-types/data/reference-data/axn";

export const formatVerificationTransactionsResponse = (
    verificationTransactionsResponse: VerificationTransactionsResponse,
    axnRelyingParties: Array<AxnRelyingParty>
): FormattedVerificationTransactionsResponse => {
    return {
        summary: verificationTransactionsResponse.summary,
        verificationTransactions: formatVerificationTransactions(
            verificationTransactionsResponse.verificationTransactions,
            axnRelyingParties
        )
    };
};